import { ModalSize, Point } from '../../types'
import useToggle from '../hooks/useToggle'
import Modal from './Modal'
import PointC from './Point'
import SingleMarkerMap from './SingleMarkerMap'

const PointPreview = ({ point, className }: { point: Point; className?: string }) => {
  const [modalOpen, mapModal] = useToggle()
  return (
    <>
      <PointC point={point} className={className} onClick={mapModal.on} />
      <Modal
        title="Preview Location"
        size={ModalSize.LG}
        open={modalOpen}
        onClose={mapModal.off}
        showFooter={false}
      >
        <div className="pt-2 -mx-4 sm:-mx-6 -mb-4">
          <SingleMarkerMap lat={point.lat} lng={point.lng} rounded={false} />
        </div>
      </Modal>
    </>
  )
}

export default PointPreview
